import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { submitExternalProviderEvaluation, resetSubmitExternalProviderEvaluation } from "./submit-evaluation";

const initialState: ProcessingState = { processing: "idle" };

export const submitExternalProviderEvaluationReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(submitExternalProviderEvaluation.fulfilled, state => {
      return {
        ...state,
        processing: "success",
      };
    })
    .addCase(submitExternalProviderEvaluation.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(submitExternalProviderEvaluation.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetSubmitExternalProviderEvaluation, () => {
    return initialState;
  });
});
